import React from 'react';
import { useTranslation } from 'react-i18next';

export const ServiceSelectionCard = ({ service, isSelected, onSelect, currency = '$' }: any) => {
  const { t } = useTranslation();
  const price = service?.extraData?.serviceCharge;
  
  // Use productCode for utility service. Default to empty array if not present.
  let utilityServices: string[] = [];
  if (Array.isArray(service?.productCode)) {
    utilityServices = service.productCode;
  } else if (service?.productCode) {
    utilityServices = [service.productCode];
  } else if (Array.isArray(service?.utilityService)) {
    utilityServices = service.utilityService;
  } else if (service?.utilityService) {
    utilityServices = [service.utilityService];
  } else {
    // If we want a fallback category, we can use the supportRequestTypeDisplay
    const category = service?.supportRequestTypeDisplay || service?.requestTypeDisplay || 'Service';
    utilityServices = [category];
  }

  // Handle price display - show FREE if amount is 0 or empty
  const isFree = price === 0 || price === '0' || price === '0.00' || !price;
  const priceDisplay = isFree 
    ? <span className="text-green-600 font-bold uppercase text-lg">{t("FREE")}</span>
    : <>{currency} {price}</>;

  return (
    <div 
      className={`flex flex-col border rounded-xl p-5 transition-all ${
        isSelected ? 'border-blue-500 ring-1 ring-blue-500 shadow-sm bg-blue-50/10' : 'border-gray-200 hover:border-gray-300 bg-white'
      }`}
    >
      <div className="flex justify-between items-start mb-2 gap-2">
        <h5 className="font-semibold text-gray-900 pr-2 leading-tight">{service.name}</h5>
        <div className="flex flex-wrap gap-1 justify-end shrink-0">
          {utilityServices.map((us: string, i: number) => (
            <span key={i} className="px-2 py-0.5 rounded-full text-[10px] font-medium tracking-wide bg-blue-50 text-blue-600 border border-blue-100 uppercase">
              {us}
            </span>
          ))}
        </div>
      </div>
      
      <p className="text-sm text-gray-500 flex-grow mb-4 leading-relaxed">{service.longDescription || t("No description available.")}</p>
      
      <div className="mb-4">
        <div className="text-xl font-bold text-slate-800">{priceDisplay}</div>
        <div className="text-[10px] text-gray-400 font-medium tracking-wider">{t("Service Charge")}</div>
      </div>
      
      <button
        onClick={() => onSelect(service.id?.toString())}
        className={`w-full py-2 rounded-lg text-sm font-medium transition-colors ${
          isSelected 
            ? 'bg-blue-50 text-blue-700 border border-blue-200 hover:bg-blue-100'
            : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50'
        }`}
      >
        {isSelected ? t("Selected") : t("Select")}
      </button>
    </div>
  );
};
